export default defineAppConfig({
  ui: {
    input: {
      base: "h-[40px] focus-visible:ring-[#777777] bg-red-500",
    },

    select: {
      base: "h-[40px] focus-visible:ring-[#777777] font-normal",
    },

  },
});
